import { createContext } from "react";

const CatelogueContext = createContext();

export default CatelogueContext;